<script lang="ts" setup>
import { t, tc } from '@/locales/i18n'
import type { TReportTableColumn } from '../../../lib/GwTable/gwTableUtils'
import { numKtoM } from '../../../../helpers/formating'
import GwUiType from '../../../lib/GwTable/GwUiType.vue'

type Props = {
  column: TReportTableColumn
  value: number
}

const protectedColumns = ['site', 'game_format']
const isProtectedColumn = (column: TReportTableColumn['field']) => protectedColumns.includes(column)

defineProps<Props>()
</script>

<template>
  <div v-if="isProtectedColumn(column.field)">
    {{ `${numKtoM(value, 1_000, 2)} ${tc(`table_totals.${column.field}`, value)}` }}
  </div>
  <div v-else>
    <GwUiType
      :value="value"
      :uiType="column.uiType"
      :severities="column.severities"
      isTableValue
    />
  </div>
</template>
